import React, { useContext, useEffect, useState } from 'react'
import { EventMetaContext, OpsPlanContext } from '../../SingleEvent'
import { Grid } from '@mui/material'
import OnsiteTeamLeader from './Fields/OnsiteTeamLeader'
import OpsManager from './Fields/OpsManager'
import ClinicalLead from './Fields/ClinicalLead'
import Description from './Fields/Description'
import VehicleMovements from './Fields/VehicleMovements'
import Location from './Fields/Location'
import SiteBuild from './Fields/SiteBuild'
import What3Words from './Fields/What3Words'
import PersonnelSummary from './Fields/PersonnelSummary'
import ResourcesSummary from './Fields/ResourcesSummary'
import S3DocumentUploadDisplay from '../../../../../components/images/S3DocumentUploadDisplay'
import ClientContact from './Fields/ClientContact'
import StaffParking from './Fields/StaffParking'
import StaffWelfare from './Fields/StaffWelfare'

const FormPanel = () => {
  const { opsPlan, setOpsPlan } = useContext(OpsPlanContext)
  const { handleSave } = useContext(EventMetaContext)

  const [somethingToUpload, setSomethingToUpload] = useState(false)

  useEffect(() => {
    if (somethingToUpload) {
      handleSave()
      setSomethingToUpload(false)
    }
  }, [somethingToUpload])

  return (
    <Grid container spacing={2}>
      <PersonnelSummary />
      <ResourcesSummary />
      <Location />
      <ClientContact />
      <What3Words />
      <OnsiteTeamLeader />
      <Description />
      <OpsManager />
      <ClinicalLead />
      <VehicleMovements />
      <SiteBuild />
      <StaffParking />
      <StaffWelfare />
    </Grid>
  )
}

export default FormPanel
